import PlayerProfileHeader from "../Components/Player/PlayerProfileHeader";
import MobPlayerProfileHeader from "../Components/MobileComponents/MobPlayerProfileHeader";
import PlayerCard from "../Components/Player/PlayerCard";
import PlalyerStat from "../Components/Player/PlayerStat";
import { useLocation, useParams } from 'react-router-dom';
import { useEffect, useState, useRef } from "react";
import axios from "axios";
import { API_BASE_URL } from "../apiConfig";
import { ChevronLeft, ChevronRight, Users } from 'lucide-react';
import { motion } from 'framer-motion';

function PlayerProfile(props) {
    const [otherPlayers, setOtherPlayers] = useState([]);
    const [playerProfile, setPlayerProfile] = useState('');
    const [teamName, setTeamName] = useState('');
    const location = useLocation();
    const teamID = location.state;
    const urls = useParams();
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);
    const scrollRef = useRef(null);

    useEffect(() => {
        const handleResize = () => setWindowWidth(window.innerWidth);
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const isMobile = windowWidth <= 1024;
    const accentYellow = '#E7C424';

    useEffect(() => {
        if (teamID) {
            axios.get(`${API_BASE_URL}/teamPlayer/${teamID}`).then((res) => {
                if (res.data) {
                    setOtherPlayers(res.data);
                }
            });
            axios.get(`${API_BASE_URL}/TeamProfile/${teamID}`).then((res) => {
                if (res.data && res.data.name) {
                    setTeamName(res.data.name);
                }
            });
        }
        axios.get(`${API_BASE_URL}/playerProfile/${urls.id}`).then((res) => {
            setPlayerProfile(res.data);
        });
    }, [urls.id, teamID])

    const scroll = (direction) => {
        if (scrollRef.current) {
            const { scrollLeft, clientWidth } = scrollRef.current;
            const scrollTo = direction === 'left' ? scrollLeft - clientWidth : scrollLeft + clientWidth;
            scrollRef.current.scrollTo({ left: scrollTo, behavior: 'smooth' });
        }
    };

    const styles = {
        outerSection: {
            background: '#FFFFFF',
            minHeight: '100vh',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            width: '100%',
        },
        container: {
            width: '100%',
            maxWidth: '1280px',
            padding: isMobile ? '16px' : '48px 32px',
            boxSizing: 'border-box',
            display: 'flex',
            flexDirection: 'column',
            gap: isMobile ? '32px' : '64px',
        },
        otherPlayersSection: {
            marginTop: '32px',
            width: '100%',
            background: 'rgba(0,0,0,0.02)',
            padding: isMobile ? '24px 16px' : '40px 32px',
            borderRadius: '8px',
            boxSizing: 'border-box',
        },
        otherPlayersHeader: {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginBottom: '32px',
        },
        titleBox: {
            display: 'flex',
            alignItems: 'center',
            gap: '12px',
        },
        title: {
            fontFamily: "'Anton', sans-serif",
            fontWeight: 400,
            fontSize: isMobile ? '24px' : '32px',
            color: '#000000',
            margin: 0,
            textTransform: 'uppercase',
            letterSpacing: '1px',
        },
        controls: {
            display: 'flex',
            gap: '12px',
        },
        arrowBtn: {
            width: '32px',
            height: '32px',
            borderRadius: '50%',
            background: '#000000',
            border: 'none',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            cursor: 'pointer',
            transition: 'all 0.3s',
            boxShadow: '0 4px 10px rgba(0,0,0,0.2)',
        },
        scrollWrapper: {
            display: 'flex',
            gap: isMobile ? '16px' : '24px',
            overflowX: 'auto',
            paddingBottom: '20px',
            scrollbarWidth: 'none',
            msOverflowStyle: 'none',
            scrollBehavior: 'smooth',
            WebkitOverflowScrolling: 'touch',
        }
    };

    return (
        <div style={styles.outerSection}>
            <div style={styles.container}>
                {playerProfile && (
                    isMobile ? <MobPlayerProfileHeader data={playerProfile} teamName={teamName} /> : <PlayerProfileHeader data={playerProfile} teamName={teamName} />
                )}

                <PlalyerStat />

                {otherPlayers.length > 0 && (
                    <div style={styles.otherPlayersSection}>
                        <div style={styles.otherPlayersHeader}>
                            <h2 style={styles.title}>Other Players</h2>
                            <div style={styles.controls}>
                                <motion.button 
                                    whileHover={{ scale: 1.1 }}
                                    whileTap={{ scale: 0.9 }}
                                    style={styles.arrowBtn} onClick={() => scroll('left')}
                                >
                                    <ChevronLeft size={20} color="#FFFFFF" />
                                </motion.button>
                                <motion.button 
                                    whileHover={{ scale: 1.1 }}
                                    whileTap={{ scale: 0.9 }}
                                    style={styles.arrowBtn} onClick={() => scroll('right')}
                                >
                                    <ChevronRight size={20} color="#FFFFFF" />
                                </motion.button>
                            </div>
                        </div>

                        <div style={styles.scrollWrapper} ref={scrollRef}>
                            {otherPlayers.map((player, id) => (
                                <div key={id} style={{ flexShrink: 0, width: isMobile ? '220px' : '260px', display: 'flex', flexDirection: 'column' }}>
                                    <PlayerCard data={player} teamId={teamID} />
                                </div>
                            ))}
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
}

export default PlayerProfile;